
import { mapGetters } from 'vuex';
import btnFollow from '~/components/public/btn-follow.vue';
export default {
  components: {
    btnFollow,
  },
  props: ['authorInfo', 'authorArticle'],
  computed: {
    ...mapGetters('user', ['userId']),
    /**
     * @description 作者详情
     */
    authorDeatil() {
      return this.authorInfo.album || this.authorInfo.column;
    },
    /**
     * @description 作者类型
     */
    authorType() {
      return this.authorInfo.album
        ? 'album'
        : this.authorInfo.column
        ? 'column'
        : null;
    },
    authorRoute() {
      const detail = this.authorInfo.album || this.authorInfo.column;
      return detail.route.replace('m.gelonghui', 'gelonghui');
    },
  },
};
